import {type Query, type RunSetQuery} from '../../../util/queryTypes';

export function getRunSets(query: Query): RunSetQuery[] {
  if (query.runSets == null) {
    return [];
  }

  return query.runSets.map(rs => ({
    baselineRunId: rs.baselineRunId,
    enabled: rs.enabled,
    entityName: rs.entityName,
    filters: rs.filters,
    grouping: rs.grouping,
    id: rs.id,
    pinnedRunIds: rs.pinnedRunIds,
    projectName: rs.projectName,
    runNameTruncationType: rs.runNameTruncationType,
    sort: rs.sort,
  }));
}
